import io from 'socket.io-client';
import { EventEmitter } from 'events';
import { EventObject } from './type';
import _ from 'lodash';
import { Cart2 } from '../modules/cart2/type';
import { getCacheField } from '../tools/get-cache-field';
import { ConnectCart, DisconnectCart, CartError, InitCart, Marketing, Result, SubmitCart, UpdateCart, ExcessTip } from './cart2';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { StateManager } from '../redux/stateManager';
import Store from '../redux/store';

// *********************
// Websocket Client
// *********************

export class WebsocketClientClass extends EventEmitter {

    private socket: SocketIOClient.Socket = {} as any;
    private tableId: number | null = null;

    /**
     * 初始化客户端
     */
    public init(url?: string) {
        const GlobalConfig = StateManager.getFromCache('GlobalConfig') || {};
        let newUrl = url ? url : GlobalConfig.WEBSOCKET_SERVER_URL;
        // init
        this.socket = io(newUrl, {
            transportOptions: {
                polling: {
                    extraHeaders: {
                        // 'origin': `QOP####${uuidv4()}`,
                    }
                }
            }
        });

        // init default events
        this.socket.on('connect', (data: any) => {
            console.log('监听 WS_CONNECT');
            Store.dispatch({ type: 'SET_CACHING', path: 'WS_CONNECT_STATUS', value: true })
            this.emit('CONNECT', data);
        });
        this.socket.on('disconnect', (data: any) => {
            console.log('监听 WS_DIS_CONNECT');
            Store.dispatch({ type: 'SET_CACHING', path: 'WS_CONNECT_STATUS', value: false })
            this.emit('DISCONNECT', data);
        });

        // init services events
        this.socket.on('JOIN_SUCCESS_MESSAGE', (data: any) => {
        });
        this.socket.on('LEAVE_SUCCESS_MESSAGE', (data: any) => {
        });
        this.socket.on('CART_ERROR', (data: CartError) => {
            console.log(data, 'CART_ERROR');
            this.emit('CART_ERROR', data);
        });

        // init cart events
        this.socket.on('INIT_CART', (data: InitCart) => {
            this.emit('INIT_CART', data);
        });
        this.socket.on('CONNECT_CART', (data: ConnectCart) => {
            this.emit('CONNECT_CART', data)
        })
        this.socket.on('DISCONNECT_CART', (data: DisconnectCart) => {
            this.emit('DISCONNECT_CART', data)
        })
        this.socket.on('RESULT', (data: Result) => {
            this.emit('RESULT', data)
        })
        this.socket.on('UPDATE_CART', (data: UpdateCart) => {
            this.emit('UPDATE_CART', data)
        })
        this.socket.on('SUBMIT_CART', (data: SubmitCart) => {
            this.emit('SUBMIT_CART', data);
            this.socket.emit('/cart/clear/requestKey', data.requestKey)
        })
        this.socket.on('MARKETING', (data: Marketing) => {
            this.emit('MARKETING', data)
        })
        this.socket.on('TO_NEXT_TURN', (data: UpdateCart) => {
            this.emit('TO_NEXT_TURN', data)
        })
        this.socket.on('CHANGE_CART_TABLE', (data: UpdateCart) => {
            this.emit('CHANGE_CART_TABLE', data)
        })
        this.socket.on('RETURN_DISHES', (data: UpdateCart) => {
            this.emit('RETURN_DISHES', data)
        })
        this.socket.on('MESSENGER', (data: { message: string, levele: string }) => {
            this.emit('MESSENGER', data)
        })
        this.socket.on('FIRST_EXCESS_WARNING', (data: ExcessTip) => {
            this.emit('FIRST_EXCESS_WARNING', data)
        })
    }

    /**
     * 连接`Websocket`服务器
     * @注意
     * 调用此方法前，必须要运行过一次`init()`。
     */
    public connect() {
        this.socket.connect();
    }

    /**
     * 加入一个订单
     * @注意
     * 调用此方法前，必须要运行过一次`init()`和`connect()`。
     */
    public joinOrder(tableId: number) {
        this.tableId = tableId;

        this.socket.emit('JOIN_ROOM', `QOP_TABLE_ID_${this.tableId}`);
        this.socket.on(`CHAT_MESSAGE`, (data: { content: EventObject }) => {

            if (_.get(data, 'content.event')) {
                switch (_.get(data, 'content.event')) {
                    // $ Create Order Request Events
                    case 'CREATE_ORDER_REQUEST_SUCCESSED': {
                        this.emit('CREATE_ORDER_REQUEST_SUCCESSED', data.content);
                        break;
                    }
                    case 'CREATE_ORDER_REQUEST_FAILED': {
                        this.emit('CREATE_ORDER_REQUEST_FAILED', data.content);
                        break;
                    }
                    case 'SEND_ORDER_REQUEST': {
                        this.emit('SEND_ORDER_REQUEST', data.content);
                        break;
                    }
                    case 'RESEND_ORDER_REQUEST': {
                        this.emit('RESEND_ORDER_REQUEST', data.content);
                        break;
                    }

                    // $ Service Events
                    case 'CART_COMMIT_OTHER': {
                        this.emit('CART_COMMIT_OTHER', data.content);
                        break;
                    }
                    case 'CART_COMMIT_QOP': {
                        this.emit('CART_COMMIT_QOP', data.content);
                        break;
                    }
                    case 'ADD_DISH_COUNT': {
                        this.emit('ADD_DISH_COUNT', data.content);
                        break;
                    }
                    case 'REMOVE_DISH_COUNT': {
                        this.emit('REMOVE_DISH_COUNT', data.content);
                        break;
                    }
                    case 'MODIFY_DISH': {
                        this.emit('MODIFY_DISH', data.content);
                        break;
                    }
                    case 'CREATE_DISH': {
                        this.emit('CREATE_DISH', data.content);
                        break;
                    }
                    case 'DELETE_DISH': {
                        this.emit('DELETE_DISH', data.content);
                        break;
                    }
                    case 'UPDATE_DISH': {
                        this.emit('UPDATE_DISH', data.content);
                        break;
                    }
                    case 'UPDATE_RESET_DISH': {
                        this.emit('UPDATE_RESET_DISH', data.content);
                        break;
                    }
                    case 'TABLE_STATUS': {
                        this.emit('TABLE_STATUS', data.content);
                        break;
                    }
                    case 'DISTRIBUTION_ID': {
                        this.emit('DISTRIBUTION_ID', data.content);
                        break;
                    }
                    case 'CUSTOMER_ID': {
                        this.emit('CUSTOMER_ID', data.content);
                        break;
                    }
                    case 'UPDATE_DISH_COUNT': {
                        this.emit('UPDATE_DISH_COUNT', data.content);
                        break;
                    }
                    case 'UPDATE_TURNRULES': {
                        this.emit('UPDATE_TURNRULES', data.content);
                        break;
                    }
                    case 'FIRST_JOIN': {
                        this.emit('FIRST_JOIN', data.content);
                        break;
                    }
                    case 'COUNT_DOWN_DISH': {
                        this.emit('COUNT_DOWN_DISH', data.content);
                        break;
                    }
                    case 'SET_NEXT_TURN_DISH': {
                        this.emit('SET_NEXT_TURN_DISH', data.content);
                        break;
                    }
                    case 'UPDATE_CONDIMENTS': {
                        this.emit('UPDATE_CONDIMENTS', data.content);
                        break;
                    }
                    case 'ADD_COMMIT_LOCK': {
                        this.emit('ADD_COMMIT_LOCK', data.content);
                        break;
                    } case 'REMOVE_COMMIT_LOCK': {
                        this.emit('REMOVE_COMMIT_LOCK', data.content);
                        break;
                    } case 'SUBMITING_CART': {
                        this.emit('SUBMITING_CART', data.content);
                        break;
                    } case 'IS_UPDATE_MENU': {
                        this.emit('IS_UPDATE_MENU', data.content);
                        break;
                    }

                    default: { break; }
                }
                delete (data.content as any).event;
            }
        });
    }

    /**
     * 离开一个订单
     * @注意
     * 调用此方法前，必须要运行过一次`init()`和`connect()`。
     */
    public leaveOrder() {
        this.socket.emit('LEAVE_ROOM', `QOP_TABLE_ID_${this.tableId}`);
        this.tableId = null;
    }

    /**
     * 断开`Websocket`服务器
     */
    public disconnect() {
        this.socket.close();
        this.socket.disconnect();
    }

    /**
     * 往所有加入此订单的客户端发送消息
     * @注意
     * 调用此方法前，必须要运行过一次`init()`、`connect()`和`joinOrder()`。
     */
    public emitOrderClients(
        data: EventObject,
        callback: Function = () => { }
    ) {
        this.socket.emit(
            'SEND_IN_ROOM',
            {
                room: `QOP_TABLE_ID_${this.tableId}`,
                title: null,
                content: data
            },
            callback
        );
    }


    /**
     * 服务端购物车 - 初始化购物车
     * @param data
     * @param callback
     */
    public initServerCart(
        data: {
            cartFind: {
                id?: string;
                orderId?: string;
                tableId?: string;
            },
            customerNum: number;
        },
        callback: Function = () => { }
    ) {
        this.socket.emit(
            '/cart2/init',
            data,
            callback
        );
    }
    /**
     * 服务端购物车 - 连接购物车
     * @param data
     * @param callback
     */
    public connectServerCart(
        data: {
            cartFind: {
                id?: string;
                orderId?: string;
                tableId?: string;
            },
            user?: { userId?: string, userName?: string, userType?: number };
            project: string;
        }
    ) {
        this.socket.emit(
            '/cart2/connect',
            data
        );
    }

    /**
     * 服务端购物车 - 更新、执行购物车
     * @param data
     * @param callback
     */
    public updateServerCart(
        data: {
            cartFind?: Cart2.CartFind,
            itemTarget: Cart2.ItemTarget,
            action: Cart2.CartAction,
            marketingConfig: Cart2.MarketingConfig,
            compatibleRules?: Cart2.CompatibleRules,
            extraR1Config?: Cart2.ExtraR1Config
        },
        callback: Function = () => { }
    ) {
        // 初始化过滤器
        this.initCartFilter({});

        console.log({
            cartFind: {
                tableId: `${getCacheField('tableId')}`,
                id: `${ServerShoppingCart.metaData?.id}`
                // orderId: `${getCacheField('orderTab.orderId')}`
            },
            ...data
        });
        this.socket.emit(
            '/cart2/update',
            {
                cartFind: {
                    tableId: `${getCacheField('tableId')}`,
                    id: `${ServerShoppingCart.metaData?.id}`
                    // orderId: `${getCacheField('orderTab.orderId')}`
                },
                ...data
            },
            callback
        );
    }

    /**
     * 服务端购物车 - 删除购物车
     * @param data
     */
    public deleteCart(): void {
        this.socket.emit(
            '/cart2/delete',
            {
                cartFind: {
                    // tableId: `${getCacheField('tableId')}`,
                    id: `${ServerShoppingCart.metaData?.id}`
                    // orderId: `${getCacheField('orderTab.orderId')}`
                },
            }
        );
    }

    /**
     * 初始化过滤器
     * - 设置符合条件的购物车
     */
    initCartFilter(data: {
        projects?: Cart2.Project[],
        turns?: number[],
        userIds?: string[],
        userNames?: string[],
        userTypes?: Cart2.UserType[],
        groupBys?: Cart2.GroupBy[],
        sortBys?: Cart2.SortBy[],
        eid?: string
    }) {
        // ! 默认使用以下格式。勿轻易更改
        this.socket.emit(
            '/cart2/filter/init',
            {
                projects: ['QOP_COP'],
                groupBys: ['TURN', 'USER'],
                sortBys: [{ key: 'turn', value: 1 }],
                ...data
            }
        );
    }

    /**
     * 服务端购物车 - 提交购物车
     * @param data
     */
    submitCart(data: {
        cartFind?: Cart2.CartFind,
        itemsInfo: Cart2.CommitDishesItem[],
        orderInfo: Cart2.CommitDishes,
        user: Pick<Cart2.User, 'userId' | 'userName' | 'userType'>,
    }) {
        console.log('提交购物车', {
            project: 'QOP_COP',
            cartFind: {
                tableId: `${getCacheField('tableId')}`,
                id: `${ServerShoppingCart.metaData?.id}`,
                orderId: `${getCacheField('orderTab.orderId')}`
            },
            ...data
        });
        this.socket.emit(
            '/cart2/submit',
            {
                project: 'QOP_COP',
                cartFind: {
                    tableId: `${getCacheField('tableId')}`,
                    id: `${ServerShoppingCart.metaData?.id}`,
                    orderId: `${getCacheField('orderTab.orderId')}`
                },
                ...data
            }
        );
        // 等待提交
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'cartButtonLoading',
            value: true,
        })
    }

    /**
     * 服务端购物车 - 批量清空购物车菜品
     * @param data
     */
    emptyCartItem(data: {
        cartFind?: Cart2.CartFind,
        itemsInfo: {
            id: string,
            ruleConfig: Cart2.RuleConfig
        }[],
    }) {
        this.socket.emit(
            '/cart2/item/delete',
            {
                cartFind: {
                    // tableId: `${getCacheField('tableId')}`,
                    id: `${ServerShoppingCart.metaData?.id}`
                    // orderId: `${getCacheField('orderTab.orderId')}`
                },
                ...data
            }
        );
    }

    /**
     * 服务端购物车 - 轮次推进
     *
     * @param cartFind 查询购物车
     * @param operation 附加操作: 将购物车菜品移至此轮
     * @returns
     */
    toNextTurn(data: {
        cartFind?: Cart2.CartFind,
        operation?: {
            withItem?: {
                itemFind: Cart2.ItemFind,
                domain: Cart2.ActionDomain
            }
        }
    }) {
        console.log({
            cartFind: {
                // tableId: `${getCacheField('tableId')}`,
                id: `${ServerShoppingCart.metaData?.id}`,
                orderId: `${getCacheField('orderTab.orderId')}`
            },
            ...data
        });
        this.socket.emit(
            '/cart2/turn/next',
            {
                cartFind: {
                    // tableId: `${getCacheField('tableId')}`,
                    id: `${ServerShoppingCart.metaData?.id}`,
                    orderId: `${getCacheField('orderTab.orderId')}`
                },
                ...data
            }
        );
    }

    toNextTurnManually(data: {
        cartFind?: Cart2.CartFind,
        operation?: {
            withItem?: {
                itemFind: Cart2.ItemFind,
                domain: Cart2.ActionDomain
            }
        }
    }) {
        try {
            const { orderTab } = Store.getState();
            this.socket.emit(
                '/cart2/to_next_turn_manually',
                {
                    cartFind: {
                        // tableId: `${getCacheField('tableId')}`,
                        id: `${ServerShoppingCart.metaData?.id}`,
                        orderId: `${orderTab.orderId}`
                    },
                    ...data
                }
            );
        } catch (err) { }
    }

}

export const WebsocketClient = new WebsocketClientClass();
WebsocketClient.setMaxListeners(100)